module.exports = __webpack_public_path__ + "static/media/icon_modalidade.3770ce7e.svg";